<section style="padding-bottom: 40px;margin-top: 60px">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div style="margin-top: 13vh"><img src="../../../assets/cls-sphere.jpg" alt="CLS logo" width="80" />
                </div>
                <div style="display: flex">
                    <div>
                        <h1 class="title section-title" style="margin-top: 40px; color: #044084">DISCONTINUED<br />
                            BROWSER DETECTED</h1>
                        <p class="hero-subtitle"
                            style="margin-left: 0; color: #044084; padding-left: 0px; padding-right: 0px;">We are sorry,
                            you are using a version of </p><br />
                        <div style="display: inline;"><a href="https://www.google.com/chrome/" target="_Blank">Google
                                Chrome</a><span style="margin-right: 10px">, </span><a
                                href="https://www.microsoft.com/en-gb/download/internet-explorer.aspx"
                                target="_Blank">Internet Explorer 9+</a>
                            <span style="margin-right: 10px">, </span><a href="https://www.apple.com/uk/safari/"
                                target="_Blank" style="margin-right: 10px">Safari </a><span
                                style="margin-right: 10px">or </span><a href="https://www.mozilla.org/en-GB/firefox/"
                                target="_Blank">Firefox</a></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section style="background-color: #f2f5f5; padding-bottom: 40px; padding-top: 60px;">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1 class="title section-title">Need Help?</h1>
                <h6>If you are uncertain, please get in touch and we will be happy to advice.</h6><br />
                <h6>CLS GROUP SERVICES LIMITED</h6>
                <h6>PO Box 574, West Malling, ME6 9PR</h6>
                <h6><a href="mailto:info@clsgroupservices.co.uk">info@clsgroupservices.co.uk</a></h6>
                <h6><a href="tel:+441732753910">+44(0) 1732 753 910</a></h6>
            </div>
        </div>
    </div>
</section>